import { render, staticRenderFns } from "./editShop.vue?vue&type=template&id=1105e23e"
import script from "./editShop.vue?vue&type=script&lang=js"
export * from "./editShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports